module.exports = __webpack_public_path__ + "static/media/sarah_chang.fa7193c7.png";